(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["noxtee-bundle-offer"] && !Shopify.designMode) return;
  try {
    const syncNoxteeBundleOffer = (offer) => {
    const selected = offer.querySelector('[data-nx-bundle-input]:checked');
    if (!selected) return;

    const variantInput = offer.querySelector('[data-nx-bundle-variant-id]');
    const submit = offer.querySelector('[ref="addToCartButton"]');
    const addToCartContainer = offer.querySelector('add-to-cart-component');

    if (variantInput) variantInput.value = selected.value;
    if (submit) submit.disabled = selected.dataset.variantAvailable !== 'true';
    if (addToCartContainer) addToCartContainer.dataset.productVariantMedia = selected.dataset.variantImage || '';

    offer.querySelectorAll('[data-nx-atc-total]').forEach((node) => {
      node.textContent = selected.dataset.variantPrice || '';
    });

    offer.querySelectorAll('[data-nx-atc-compare]').forEach((node) => {
      node.textContent = selected.dataset.variantCompare || '';
    });

    const productId = offer.dataset.productId;
    const section = offer.closest('.shopify-section');
    const sticky = section?.querySelector(`sticky-add-to-cart[data-product-id="${productId}"]`);

    if (sticky) {
      sticky.dataset.currentVariantId = selected.value;
      sticky.dataset.variantAvailable = selected.dataset.variantAvailable;

      const title = sticky.querySelector('.nx-satc__variant');
      const price = sticky.querySelector('.nx-satc__price');
      const image = sticky.querySelector('[ref="productImage"]');

      if (title) title.textContent = selected.dataset.variantTitle || '';
      if (price) price.textContent = selected.dataset.variantPrice || '';
      if (image && selected.dataset.variantImage) image.src = selected.dataset.variantImage;
    }
  };

  const initializeNoxteeBundleOffers = (root = document) => {
    root.querySelectorAll('[data-nx-bundle-offer]').forEach(syncNoxteeBundleOffer);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-nx-bundle-input]');
    if (!input) return;
    syncNoxteeBundleOffer(input.closest('[data-nx-bundle-offer]'));
  });

  document.addEventListener('shopify:section:load', (event) => initializeNoxteeBundleOffers(event.target));

  const initializeNoxteePurchaseProof = (root = document) => {
    root.querySelectorAll('[data-nx-purchase-proof]').forEach((proof) => {
      if (proof.dataset.nxProofReady === 'true') return;

      const slides = [...proof.querySelectorAll('[data-nx-proof-slide]')];
      const count = proof.querySelector('[data-nx-proof-count]');
      if (slides.length < 2) return;

      let activeIndex = 0;
      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          slide.hidden = index !== activeIndex;
        });
        if (count) count.textContent = `${activeIndex + 1}/${slides.length}`;
      };

      proof.querySelector('[data-nx-proof-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      proof.querySelector('[data-nx-proof-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
      proof.dataset.nxProofReady = 'true';
      showSlide(0);
    });
  };

  document.addEventListener('shopify:section:load', (event) => initializeNoxteePurchaseProof(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeNoxteeBundleOffers();
      initializeNoxteePurchaseProof();
    });
  } else {
    initializeNoxteeBundleOffers();
    initializeNoxteePurchaseProof();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["noxtee-pdp-intro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-nx-clinician-open]');

    if (opener) {
      const intro = opener.closest('.nx-pdp-intro');
      const dialog = intro?.querySelector('.nx-clinician-dialog');

      if (dialog) dialog.showModal();
    }

    const closer = event.target.closest('[data-nx-clinician-close]');

    if (closer) closer.closest('.nx-clinician-dialog')?.close();

    if (event.target.matches('.nx-clinician-dialog')) event.target.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["noxtee-sales-carousel"] && !Shopify.designMode) return;
  try {
    const initNoxteeSalesCarousel = (root) => {
    if (root.dataset.nxCarouselReady === 'true') return;

    const viewport = root.querySelector('[data-nx-carousel-viewport]');
    const slides = [...root.querySelectorAll('[data-nx-carousel-slide]')];
    const dots = [...root.querySelectorAll('[data-nx-carousel-dot]')];
    const previous = root.querySelector('[data-nx-carousel-previous]');
    const next = root.querySelector('[data-nx-carousel-next]');
    if (!viewport || slides.length === 0) return;

    root.dataset.nxCarouselReady = 'true';
    let activeIndex = 0;
    let frame;

    const update = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goTo = (index) => {
      const target = (index + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
      update(target);
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        update(Math.max(0, Math.min(slides.length - 1, index)));
      });
    }, { passive: true });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
      }
    });
  };

  const initAllNoxteeSalesCarousels = (scope = document) => {
    scope.querySelectorAll('[data-nx-sales-carousel]').forEach(initNoxteeSalesCarousel);
  };

  initAllNoxteeSalesCarousels();
  document.addEventListener('shopify:section:load', (event) => initAllNoxteeSalesCarousels(event.target));
  } catch(e) { console.error(e); }
})();

})();
